<span class="cta-chip" [ngClass]="'cta-theme-'+theme">{{text}}</span>
